import React from 'react';
import { DefaultLink } from 'components/static-footer/styled';
import { Route } from 'config/routes';

interface UploadBulletinLinkProps {
  text: string;
  source: 'topbar' | 'home_page_footer_bar';
  icon?: JSX.Element;
  showAgentConsoleBulletinForm: boolean;
}

const UPLOAD_BULLETIN_OLD_ROUTE_NAME = Route.UploadBulletin;
const UPLOAD_BULLETIN_AGENT_CONSOLE_ROUTE_NAME = Route.UploadBulletinForm;

export const UploadBulletinLink: React.FC<UploadBulletinLinkProps> = (props) => {
  const {
    icon,
    text,
    source,
    showAgentConsoleBulletinForm,
  } = props;

  const routeName = showAgentConsoleBulletinForm
    ? UPLOAD_BULLETIN_AGENT_CONSOLE_ROUTE_NAME
    : UPLOAD_BULLETIN_OLD_ROUTE_NAME;

  return (
    <DefaultLink routeName={routeName} routeParams={{ source }} hideLinkParams data-auto="upload-listing">
      {icon}
      {text}
    </DefaultLink>
  );
};

UploadBulletinLink.defaultProps = {
  icon: null,
};
